export default __webpack_public_path__ + "static/sub-logo-cht-c2f4437167154a04d1a5e4dedc550dbd.png";